"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var VideoConferenceComponent =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(VideoConferenceComponent, _PureComponent);

  function VideoConferenceComponent() {
    (0, _classCallCheck2.default)(this, VideoConferenceComponent);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(VideoConferenceComponent).apply(this, arguments));
  }

  (0, _createClass2.default)(VideoConferenceComponent, [{
    key: "render",
    value: function render() {
      var block = this.props.block;
      var blockData = block.getData();
      var text = blockData.get('text');
      var textToRender = (0, _typeof2.default)(text) === 'object' ? text.innerHTML : text; // eslint-disable-next-line react/no-danger

      return _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: textToRender
        }
      });
    }
  }]);
  return VideoConferenceComponent;
}(_PureComponent2.default);

var _default = VideoConferenceComponent;
exports.default = _default;
module.exports = exports.default;